import React, { useEffect, useState } from "react";
import "./AddIncome.css";
import ButtonSpinner from "../../../../Components/Spinners/ButtonSpinner";
import AddIncomeViewModal from "./AddIncomeViewModal";
import { Autocomplete, Avatar, TextField } from "@mui/material";
import { StringAvatar } from "../../../../Helpers/StringAvatar";
import IsSchoolAdded from "../../../../Hooks/IsSchoolAdded";
import { Link } from "react-router-dom";
import Select from "react-select";
const AddIncome = () => {
  const {
    NewIncome,
    setNewIncome,
    AddNewIncome,
    IncomeNameError,
    IncomeTypeError,
    IncomeDateError,
    IncomeAmountError,
    IsUpdate,
    loader,
    StudentId,
    setStudentId,
    AllStudents,
    setAllStudents,
    IncomeStudentError,
  } = AddIncomeViewModal();

  console.log("IncomeTypeError", IncomeTypeError);

  const SchoolAddedResp = IsSchoolAdded();
  return (
    <div className="page-wrapper add-income-page-container">
      <div className="content container-fluid">
        {/* Page Header */}
        <div className="page-header">
          <div className="row align-items-center">
            <div className="col">
              <h3 className="page-title">
                {IsUpdate ? "Update Income" : "Add Income"}
              </h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/user/admin/dashboard">Accounts</Link>
                </li>
                <li className="breadcrumb-item active">
                  {IsUpdate ? "Update Income" : "Add Income"}
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* /Page Header */}
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-12">
                      <h5 className="form-title">
                        <span>Income Information</span>
                      </h5>
                      {!SchoolAddedResp && (
                        <div className="add-school-first-container">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-exclamation-triangle-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                          </svg>
                          <p>Please add school first!</p>
                        </div>
                      )}
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group local-forms">
                        <label>
                          Income Type <span className="login-danger">*</span>
                        </label>

                        <Select
                          className={`select-expense-type ${
                            IncomeTypeError ? "select-expense-type-error" : ""
                          }`}
                          onChange={(e) => {
                            setNewIncome({
                              ...NewIncome,
                              IncomeType: e.value,
                            });
                          }}
                          defaultValue={NewIncome?.IncomeType}
                          disabled={loader || !SchoolAddedResp}
                          options={[
                            {
                              value: "Income",
                              label: "Select Income type",
                              isDisabled: true,
                            },
                            { value: "fee", label: "Fee" },
                            { value: "others", label: "Others" },
                          ]}
                        />
                      </div>
                    </div>
                    {NewIncome.IncomeType === "fee" && (
                      <div className="col-12 col-sm-4">
                        <Autocomplete
                          id="tags-outlined"
                          options={AllStudents}
                          getOptionLabel={(option) =>
                            option?.FirstName + " " + option?.LastName
                          }
                          onChange={(event, value, reason, details) => {
                            setStudentId(details.option.uid);
                          }}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option.id}>
                                <Avatar
                                  {...StringAvatar(
                                    option?.FirstName + option?.LastName
                                  )}
                                />
                                <span className="name-reg-container">
                                  <span className="user-name">
                                    {option?.FirstName + " " + option?.LastName}
                                  </span>
                                  <span className="reg-no">
                                    Reg No:
                                    {
                                      option?.AdditionalDetails
                                        ?.StudentRegistrationNo
                                    }
                                  </span>
                                </span>
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              error={IncomeStudentError ? true : false}
                              {...params}
                              InputProps={{
                                ...params.InputProps,
                              }}
                              InputLabelProps={{ shrink: true }}
                              label="Select student"
                            />
                          )}
                        />
                      </div>
                    )}

                    <div className="col-12 col-sm-4">
                      <div className="form-group local-forms">
                        <label>
                          Income Name <span className="login-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            IncomeNameError === true && "error-message"
                          }`}
                          onChange={(e) => {
                            setNewIncome({
                              ...NewIncome,
                              IncomeName: e.target.value,
                            });
                          }}
                          value={NewIncome?.IncomeName}
                          disabled={loader || !SchoolAddedResp}
                        />
                        {IncomeNameError ? (
                          <span className="income-tooltip">
                            <i className="fa-solid fa-info icon-after-submit"></i>
                            <span className="text-after-submit">
                              Income name is required
                            </span>
                          </span>
                        ) : (
                          <span className="income-tooltip">
                            <i className="fa-solid fa-info text-info"></i>
                            <span className="income-tooltip-text">
                              income name is required
                            </span>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group local-forms">
                        <label>
                          Date <span className="login-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className={`form-control ${
                            IncomeDateError === true && "error-message"
                          }`}
                          onChange={(e) => {
                            setNewIncome({
                              ...NewIncome,
                              Date: e.target.value,
                            });
                          }}
                          value={NewIncome?.Date}
                          disabled={loader || !SchoolAddedResp}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group local-forms">
                        <label>
                          Income Amount <span className="login-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control ${
                            IncomeAmountError === true && "error-message"
                          }`}
                          onChange={(e) => {
                            setNewIncome({
                              ...NewIncome,

                              IncomeAmount:
                                e.target.value < 0 ? 0 : e.target.value,
                            });
                          }}
                          value={NewIncome?.IncomeAmount}
                          disabled={loader || !SchoolAddedResp}
                        />
                        {IncomeAmountError ? (
                          <span className="income-tooltip">
                            <i className="fa-solid fa-info icon-after-submit"></i>
                            <span className="text-after-submit">
                              Income Amount is required
                            </span>
                          </span>
                        ) : (
                          <span className="income-tooltip">
                            <i className="fa-solid fa-info text-info"></i>
                            <span className="income-tooltip-text">
                              Income Amount
                            </span>
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="student-submit">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={(e) => {
                            e.preventDefault();
                            AddNewIncome();
                          }}
                          disabled={loader || !SchoolAddedResp}
                        >
                          {loader && <ButtonSpinner />}
                          {IsUpdate ? "Update" : "Submit"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddIncome;
